import BtEditableBox from '@common-components/tasks/bt-editable-box/bt-editable-box';
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import { Stack } from '@mui/system';
import { setTemplateName } from '@common/reducers/ScheduledMessageEditorReducer';
import { useTranslation } from 'react-i18next';
import { namespace } from '@common/config/constants';


type Props = {
    // No props needed - reads directly from Redux
}

export default function TemplateHeader({}: Props) {
    const { t } = useTranslation(namespace);
    const dispatch = useAppDispatch()

    // Read directly from ScheduledMessageEditorReducer - single source of truth
    const templateName = useAppSelector((state: any) => state.ScheduledMessageEditorReducer.templateName);
    const templateId = useAppSelector((state: any) => state.ScheduledMessageEditorReducer.templateId);

    const inputTheme = {
        color: "var(--color-primary)",
        width: "100%",
        padding: "0 10px",
        fontSize: "36px",
        fontWeight: "700",
        borderRadius: "8px",
        border: "1px solid var(--color-accent)",
        fontFamily: "'Poppins', 'Assistant', sans-serif",
        "& .MuiInputBase-input": {
            padding: "0",
        },
    };
    const textTheme = {
        color: "var(--color-primary)",
        fontSize: "36px",
        padding: "0 10px",
        border: "1px solid transparent",
        borderRadius: "8px",
        fontWeight: "700",
        fontFamily: "'Poppins', 'Assistant', sans-serif",
        "&:hover": {
            border: templateId && "1px dashed var(--tasks-text-secondary)",
        },
    };

    return (
        <Stack direction='column' sx={{
            justifyContent: 'center',
            alignItems: 'center',
            m: '0 0 24px 0',
        }}>
            <BtEditableBox
                preventClickEdit={!templateId}
                placeholder='Enter Template Name'
                inputSx={inputTheme}
                boxSx={textTheme}
                text={templateName}
                centerText={true}
                onValueUpdate={(newValue) => {
                    // Update ScheduledMessageEditorReducer directly - single source of truth
                    dispatch(setTemplateName(newValue));
                }}
            />
            <span style={{
                textAlign: 'center',
                fontSize: '17px',
                fontWeight: '400',
                marginTop: '10px',
                marginBottom: '10px',
            }}>{t('messageEditor.addTextEmojisLinksLabelsAndFiles')}</span>
        </Stack>
    )
}